import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import { Modal, Button } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import { ordenarListaAlfabetica } from './superadminSortUtils';
import './SuperadminStyles.css';

const TiposContrato = () => {
    const history = useHistory();
    const [tiposContrato, setTiposContrato] = useState([]);
    const [filteredTiposContrato, setFilteredTiposContrato] = useState([]);
    const [loading, setLoading] = useState(true);
const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [tipoContratoToDelete, setTipoContratoToDelete] = useState(null);
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });
    const itemsPerPage = 20;

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        fetchTiposContrato();
    }, [history]);

    useEffect(() => {
        const filtered = tiposContrato.filter(tipo =>
            tipo.nombre.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredTiposContrato(ordenarListaAlfabetica(filtered, 'nombre'));
        setCurrentPage(1);
    }, [searchTerm, tiposContrato]);

    const fetchTiposContrato = async () => {
        try {
            const response = await axios.get('/superadmin/tipos-contrato');
            const ordenados = ordenarListaAlfabetica(response.data, 'nombre');
            setTiposContrato(ordenados);
            setFilteredTiposContrato(ordenados);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching tipos contrato:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('superadmin_token');
                localStorage.removeItem('superadmin_user');
                history.push('/superadmin/login');
            }
            setLoading(false);
        }
    };

    const handleDeleteClick = (tipoContrato) => {
        setTipoContratoToDelete(tipoContrato);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await axios.delete(`/superadmin/tipos-contrato/${tipoContratoToDelete.id}`);
            setAlert({
                show: true,
                type: 'success',
                message: 'Tipo de contrato eliminado exitosamente'
            });
            fetchTiposContrato();
        } catch (error) {
            console.error('Error deleting tipo contrato:', error);
            const message = error.response?.data?.message || 'No se puede eliminar el tipo de contrato porque está en uso por usuarios';
            setAlert({
                show: true,
                type: 'danger',
                message: message
            });
        } finally {
            setShowDeleteModal(false);
            setTipoContratoToDelete(null);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    // Paginación
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredTiposContrato.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredTiposContrato.length / itemsPerPage);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <SuperadminLayout>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h4><i className="fas fa-file-contract"></i> Tipos de Contrato</h4>
                                <Link to="/superadmin/tipos-contrato/nuevo" className="btn btn-superadmin">
                                    <i className="fas fa-plus"></i> Nuevo Tipo de Contrato
                                </Link>
                            </div>

                            {/* Alertas */}
                            {alert.show && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ show: false, type: '', message: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            {/* Búsqueda */}
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar tipo de contrato..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            {/* Tabla */}
                            <div className="table-responsive">
                                <table className="table table-hover superadmin-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nombre</th>
                                            <th>Fecha Creación</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length > 0 ? (
                                            currentItems.map(tipoContrato => (
                                                <tr key={tipoContrato.id}>
                                                    <td>{tipoContrato.id}</td>
                                                    <td>{tipoContrato.nombre}</td>
                                                    <td>{new Date(tipoContrato.created_at).toLocaleDateString()}</td>
                                                    <td>
                                                        <Link
                                                            to={`/superadmin/tipos-contrato/editar/${tipoContrato.id}`}
                                                            className="btn btn-sm btn-dark mr-2"
                                                        >
                                                            <i className="fas fa-edit"></i> Editar
                                                        </Link>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => handleDeleteClick(tipoContrato)}
                                                        >
                                                            <i className="fas fa-trash"></i> Eliminar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">
                                                    No se encontraron tipos de contrato
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            {totalPages > 1 && (
                                <nav>
                                    <ul className="pagination justify-content-center">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Anterior
                                            </button>
                                        </li>
                                        {[...Array(totalPages)].map((_, index) => (
                                            <li
                                                key={index + 1}
                                                className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Siguiente
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
            {/* Modal de Confirmación */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro que desea eliminar el tipo de contrato <strong>{tipoContratoToDelete?.nombre}</strong>?
                    <br /><br />
                    <small className="text-danger">
                        Nota: No se puede eliminar si está en uso por usuarios.
                    </small>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
        </SuperadminLayout>
    );
};

export default TiposContrato;
